export const hubPackagesTypes = {
  GET_HUB_PACKAGES_DATA_LOADING: 'GET_HUB_PACKAGES_DATA_LOADING',
  GET_HUB_PACKAGES_DATA_SUCCESS: 'GET_HUB_PACKAGES_DATA_SUCCESS',
  GET_HUB_PACKAGES_DATA_ERROR: 'GET_HUB_PACKAGES_DATA_ERROR',
  SAVE_HUB_PACKAGES_DATA_SUCCESS: 'SAVE_HUB_PACKAGES_DATA_SUCCESS',

  GET_HUB_CARGO_DATA_LOADING: 'GET_HUB_CARGO_DATA_LOADING',
  GET_HUB_CARGO_DATA_SUCCESS: 'GET_HUB_CARGO_DATA_SUCCESS',
  GET_HUB_CARGO_DATA_ERROR: 'GET_HUB_CARGO_DATA_ERROR'
}